/** Global search results (QM-D02-004): scoped server-side to the active workspace and my roles. */
import { Link, useSearchParams } from 'react-router';
import type { SearchHit } from '@qm/contracts/shell';
import { EmptyState, ErrorState, Heading, Loading } from '@qm/ui';
import { useApp } from '../../../lib/app-context';
import { useFormat } from '../../../lib/format';
import { useResource } from '../../../lib/resource';
import { useFlags } from '../../../lib/flags';
import { visiblePath } from '../_shared/ModuleGate';

export function SearchPage() {
  const { t } = useApp();
  const f = useFormat();
  const [params] = useSearchParams();
  const q = (params.get('q') ?? '').trim();
  const res = useResource<SearchHit[]>(q.length >= 2 ? `/v1/shell/search?q=${encodeURIComponent(q)}` : null);
  const flag = useFlags();
  // Phase 1 (G10): hits inside hidden modules are not offered
  const hits = res.status === 'ready' ? res.data.filter((h) => visiblePath(h.path, flag)) : [];
  return (
    <section className="qm-page" aria-labelledby="page-title">
      <Heading level={1} id="page-title">{t('shell.search.results', { q: f.text(q) })}</Heading>
      {q.length < 2 ? <EmptyState title={t('shell.search.tooShort')} /> : res.status === 'loading' ? <Loading label={t('common.loading')} /> : res.status === 'error' ? <ErrorState message={t('shell.error.load')} /> : !hits.length ? <EmptyState title={t('shell.search.none')} /> : (
        <ul className="qm-list">
          {hits.map((h) => (
            <li key={h.id} className="qm-list__item">
              <Link to={h.path}><bdi>{f.text(h.title)}</bdi></Link>
              <span>{t(`shell.search.kind.${h.kind}`)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
